export function DownloadFile(file, fileName) {
    console.log('in download manager');
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;

    var blob = new window.Blob([file], {
        type: 'application/xml ; charset = utf-8'
    })

    if (isIE) {
        /*         console.log('INTERNET EXPLO...');
                console.log('file: ' + file);
                console.log('filename: ' + fileName); */
        window.navigator.msSaveBlob(blob, fileName);
    } else {

        var blobURL = window
            .URL
            .createObjectURL(blob);
        var a = document.createElement("a");
        document
            .body
            .appendChild(a);
        a.style = "display: none";
        a.href = blobURL;
        a.download = fileName;
        a.click();
        a.remove();
        window
            .URL
            .revokeObjectURL(blobURL);
    }

}
//PDF//
export function createFile(arrayBuffer) {
    var file = []
    var buffer = []
    arrayBuffer.map((chunckStream) => {
        var arrayDatiBuffer = chunckStream.data
        var uint8 = new Uint8Array(arrayDatiBuffer.length);
        uint8.set(arrayDatiBuffer)
        var buffer = uint8.buffer
        file.push(buffer)
    });
    return file;
}

export function SaveFile(file, fileName) {

    var isIE = /*@cc_on!@*/ false || !!document.documentMode;

    var blob = new window.Blob(file, {
        type: "octet/stream"
    })

    if (isIE) {
        /*         console.log('INTERNET EXPLO...');
                console.log('file: ' + file);
                console.log('filename: ' + fileName); */
        window.navigator.msSaveBlob(blob, fileName);
    } else {

        var blobURL = window
            .URL
            .createObjectURL(blob);
        var a = document.createElement("a");
        document
            .body
            .appendChild(a);
        a.style = "display: none";
        a.href = blobURL;
        a.download = fileName;
        a.click();
        a.remove();
        window
            .URL
            .revokeObjectURL(blobURL);
    }

}

export function DownloadBlobToPdf(blob, fileName) {


    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    if (isIE) {
        //IE11 & Edge
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
    }

}

/* export function SaveFromBase64ToPdf(data,filename) {
    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], {
        type: 'application/pdf;base64'
    });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
} */